import React, { useCallback, useMemo, useRef, useState } from 'react';
import styles from './dropdown.module.scss';
import ArrowDownIcon from '../../../assets/icons/chevron_down.svg?react';
import { useOnClickOutside } from '../../../hooks/useClickOutside';
import Link from '../link/Link';
import { isHomeEDApp } from '@src/constants';

type ListItem = {
  title: string;
  onClick?: (e?: any) => void;
  href?: string;
  Icon?: React.ReactNode | JSX.Element;
  to?: string;
}

type Props = {
  title: string | React.ReactNode | JSX.Element;
  onClickTitle?: () => void;
  isTitleButton?: boolean;
  list?: ListItem[];
  inviteButton?: boolean;
  isProfile?: boolean;
  noVerticalDividerCaretOrangeButton?: boolean;
  heButton?: boolean;
};

function DropDown({
  title,
  onClickTitle,
  list,
  isTitleButton,
  isProfile,
  inviteButton,
  noVerticalDividerCaretOrangeButton,
  heButton
}: Props) {
  const [showMenu, setShowMenu] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleCloseMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  const handleToggleMenu = useCallback(() => {
    setShowMenu(menuState => !menuState);
  }, []);

  useOnClickOutside(wrapperRef, () => handleCloseMenu());

  const inviteUser = useCallback(() => {
    onClickTitle && onClickTitle();
    setShowMenu(false);
  }, [onClickTitle]);

  const onMenuClick = useCallback((handler: () => void, e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    handler && handler();
  }, []);

  const onHandleTitle = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    onClickTitle && onClickTitle();
    handleToggleMenu();
  }, [onClickTitle, handleToggleMenu])

  const classes = useMemo(() => {
    const classes = [styles.wrapper];
    if (showMenu) {
      classes.push(styles.open);
    }
    if (isHomeEDApp) {
      classes.push(styles.homeEdWrapper)
    }
    return classes.join(' ');
  }, [showMenu]);

  return (
    <div className={`${classes} ${inviteButton ? `${styles.wrapperPaddingOnButton}` : ''}`} ref={wrapperRef}>
      {isTitleButton ? (
        <div className={`${styles.buttonContainer}`}>
          <button className={`${heButton ? styles.heButton : styles.titleButton} ${heButton ? styles.heButtonWidth : styles.titleButtonWidth}`}
                  onClick={inviteUser}>{title}</button>
          <button className={`${styles.arrowButton} ${showMenu ? styles.upArrow : ''}`} onClick={handleToggleMenu}>
            <ArrowDownIcon /></button>
        </div>
      ) : noVerticalDividerCaretOrangeButton ? (
          <div className={`${styles.buttonContainer}`}>
            <button
              className={`${heButton ? styles.heButton : styles.titleButton} ${heButton ? styles.heButtonWidth : styles.titleButtonWidth} ${styles.noVerticalDividerCaretOrangeButton}`} style={{textTransform: "uppercase"}}
              onClick={handleToggleMenu}>{title}
              <span className={`${styles.arrowSingleButton} ${showMenu ? styles.upArrow : ''}`}><ArrowDownIcon/></span>
            </button>
          </div>
        ) :
        (
          <div className={styles.buttonContainer}>
            <Link onClick={onHandleTitle} href="#" className={`${styles.tabletBtn} ${showMenu ? styles.upArrow : ''} ${isHomeEDApp ? styles.transparent : ''}`}>
              {title}
              <ArrowDownIcon/>
            </Link>
          </div>
        )}
      <ul
        className={`${styles.list} ${inviteButton ? `${styles.inviteButtonList}` : ''} ${isProfile ? `${styles.profileList}` : ''}`}>
        {
          (list || []).map((item, key) => {
            return (
              <li className={styles.listItem} key={key}>
                <Link className={styles.titleButton}
                  onClick={item.href || item.to ? undefined : (e) => {
                    if (item.onClick) onMenuClick(item.onClick, e);
                  }} href={item.href}
                  target={item.href ? '_blank' : undefined} to={item.to}>
                  {item.title}
                  {item.Icon ? item.Icon : null}
                </Link>
              </li>
            )
          })
        }
      </ul>
    </div>
  );
}

export default DropDown;
